import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServicesService } from './_services/services.service';
import { AuthenticationService } from './_services/authentication.service';
import { AlertService } from './_services/alert.service';
import { StorageService } from './_services/storage.service';
import { SpinnerService } from './_services/spinner.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { LanguageService } from './_services/language.service';
import { HttpErrorInterceptorService } from './_interceptors/http-error-interceptor.service';
import { LoadingSpinnerInterceptorService } from './_interceptors/loading-spinner-interceptor.service';
import { UserService } from './_services/user.service';
import { SaveTempService } from './_services/save-temp.service';
import { CheckProfileService } from './_services/check-profile.service';
import { JwtInterceptorService } from './_interceptors/jwt-interceptor.service';
import { AutocompleteService } from './_services/autocomplete.service';
import { VehicleService } from './_services/vehicle.service';
import { CommonService } from './_services/common.service';
import { GoogleMapsService } from './_services/google-maps.service';
import { UploadService } from './_services/upload.service';
import { CustomerService } from './_services/customer.service';
import { PricelistService } from './_services/pricelist.service';
import { AccountService } from './_services/account.service';
import { PlannerService } from './_services/planner.service';
import { DriversService } from './_services/drivers.service';
import { PartnerService } from './_services/partner.service';
import { AppDriverService } from './_services/app-driver.service';
import { ClientLogService } from './_services/client-log.service';

export function initConfig(config: AppConfig) {
	return () => config.load();
}

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		HttpClientModule
	],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: LoadingSpinnerInterceptorService, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptorService, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true },
		{ provide: LOCALE_ID, useValue: 'it-IT' },
		AppConfig,
		{ provide: APP_INITIALIZER, useFactory: initConfig, deps: [AppConfig], multi: true },
		ServicesService,
		AuthenticationService,
		UserService,
		LanguageService,
		CheckProfileService,
		AutocompleteService,
		CommonService,
		VehicleService,
		AlertService,
		GoogleMapsService,
		StorageService,
		SpinnerService,
		SaveTempService,
		UploadService,
		CustomerService,
		PricelistService,
		AccountService,
		PlannerService,
		DriversService,
		PartnerService,
		AppDriverService,
		ClientLogService
	]
})
export class RootModule { }
